module.exports = __webpack_public_path__ + "img/android-chrome-192x192.4d5b8763.png";